<template>
  <div class="my-register-page">
    <div class="my-container">
      <div>
        <b-row>
          <b-col>
            <h1>{{ $t("MaxsusGuvohnoma") }}</h1>
          </b-col>
        </b-row>

        <b-row class="mt-4">
          <b-col sm="12" md="4">
            <custom-input
              @keyup.native.enter="Refresh"
              v-model="filter.certificateNumber"
              :type="'text'"
              :label="$t('certificateNumberLabel')"
              :placeholder="$t('certificateNumberLabel')"
            />
          </b-col>
          <b-col sm="12" md="3">
            <custom-button block @click.native="Refresh">
              <span>
                <b-spinner
                  style="margin-left : 20px"
                  v-if="SearchLoading"
                  small
                ></b-spinner>
                {{ $t("search") }}
              </span>
            </custom-button>
          </b-col>
        </b-row>

        <div
          v-if="!SearchLoading && Searched && LastSearchedCert && Inspector.length === 0"
          class="no-right-alert mt-4"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            fill="#DC2626"
            viewBox="0 0 16 16"
          >
            <path
              d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5m.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2"
            />
          </svg>
          <span>{{ $t("noInspectionRight") }}</span>
        </div>

        <b-row class="mt-4">
          <b-col
            sm="12"
            md="6"
            lg="4"
            class="my-2 d-flex"
            v-for="(item, index) in Inspector"
            :key="index"
          >
            <div class="guv-card">
              <div class="guv-card__header"></div>
              <div class="guv-card__photo">
                <img
                  :src="item.photo || '/images/design/empty_avatar.svg'"
                  alt="avatar"
                  class="guv-photo"
                  :class="{ 'guv-photo--placeholder': !item.photo }"
                />
              </div>
              <div class="guv-card__body">
                <h3 class="guv-card__name">{{ item.fullName }}</h3>
                <p class="guv-card__position">{{ item.position }}</p>

                <div class="guv-details">
                  <p class="guv-row">
                    <span class="my-text-primary">
                      {{ $t("certificateNumbeR") }} :
                    </span>
                     <span>{{ item.certificateNumber }}</span>
                  </p>
                  <p class="guv-row">
                    <span class="my-text-primary">
                      {{ $t("expirationDate") }} :
                    </span>
                     <span>{{ item.expirationDate }}</span>
                  </p>
                  <p class="guv-row">
                    <span class="my-text-primary">
                      {{ $t("parentOrganization") }} :
                    </span>
                     <span>{{ item.parentOrganization }}</span>
                  </p>
                  <p class="guv-row">
                    <span class="my-text-primary">
                      {{ $t("Organization") }} :
                    </span>
                     <span>{{ item.organization }}</span>
                  </p>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import { BRow, BCol, BSpinner } from "bootstrap-vue";
import customInput from "../../components/elements/customInput.vue";
import customButton from "../../components/elements/customButton.vue";
import InspectorService from "@/services/inspector.service";

export default {
  components: {
    BRow,
    BCol,
    BSpinner,
    customInput,
    customButton,
  },
  data() {
    return {
      SearchLoading: false,
      Searched: false,
      LastSearchedCert: "",
      filter: {
        certificateNumber: "",
      },
      Inspector: [],
    };
  },
  created() {
    this.Refresh();
  },
  methods: {
    Refresh() {
      this.SearchLoading = true;
      const cert = (this.filter.certificateNumber || "").trim();
      this.LastSearchedCert = cert;
      const request = cert
        ? InspectorService.Get(encodeURIComponent(cert))
        : InspectorService.Get();

      request
        .then((res) => {
          const data = res.data;
          this.Inspector = Array.isArray(data)
            ? data
            : data
            ? [data]
            : [];
          this.SearchLoading = false;
          this.Searched = true;
          this.LoadPhotos();
        })
        .catch((error) => {
          this.SearchLoading = false;
          this.Searched = true;
          this.Inspector = [];
          this.makeToast(error.response.data.errors, "error");
        });
    },
    LoadPhotos() {
      this.Inspector.forEach((item, index) => {
        const pinfl = item.pinfl;
        const docGiveDate = item.birthDate;
        InspectorService.GetPersonPhoto({ pinfl, docGiveDate })
          .then((res) => {
            const blob = res && res.data;
            if (!blob || !blob.size) return;
            const src = URL.createObjectURL(blob);
            this.$set(this.Inspector[index], "photo", src);
          })
          .catch(() => {});
      });
    },
    makeToast(message, type) {
      let a = "";
      if (message && message.status == 500) a = message.title;
      else if (message && message.status == 400) {
        const errors = Object.values(message.errors);
        a = errors.map((el, i) => i + 1 + "." + el).join("\n");
      } else a = message;
      this.$toast.open({
        message: a,
        type,
        duration: 5000,
        dismissible: true,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";

.guv-card {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #ffffff;
  border-radius: 20px;
  padding: 0 24px 28px;
  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.08);
  overflow: hidden;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 14px 28px rgba(63, 117, 254, 0.18);
  }

  &__header {
    width: 100%;
    height: 110px;
    margin: 0 -24px;
    background: $primary;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }

  &__photo {
    display: flex;
    justify-content: center;
    margin-top: -65px;
    margin-bottom: 14px;
  }

  &__body {
    flex: 1 1 auto;
    width: 100%;
    text-align: center;
  }

  &__name {
    margin: 0;
    font-size: 22px;
    font-weight: 700;
    color: #1F2937;
    line-height: 1.25;
    word-break: break-word;
  }

  &__position {
    margin: 6px 0 16px;
    font-size: 14px;
    color: #6B7280;
    font-weight: 500;
  }

  &__footer {
    width: 100%;
    margin-top: 18px;
    display: flex;
    justify-content: center;
  }
}

.guv-photo {
  width: 120px;
  height: 150px;
  object-fit: cover;
  background: #F3F4F6;
  border: 5px solid #ffffff;
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.12);

  &--placeholder {
    object-fit: cover;
    background: #E2E8F0;
  }
}

.guv-details {
  text-align: left;
  background: #F9FAFB;
  border-radius: 12px;
  padding: 14px 16px;
  margin-top: 4px;
}

.guv-row {
  margin-bottom: 8px;
  line-height: 1.45;
  word-break: break-word;
  font-size: 14px;

  &:last-child {
    margin-bottom: 0;
  }
}

.no-right-alert {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 16px 20px;
  background: #FEF2F2;
  color: #DC2626;
  border: 1px solid #FECACA;
  border-radius: 12px;
  font-weight: 600;
  font-size: 15px;
}

.inspection-right-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 32px;
  background: $primary;
  color: #ffffff;
  font-weight: 600;
  font-size: 15px;
  border-radius: 999px;
  box-shadow: 0 6px 14px rgba(63, 117, 254, 0.35);
}
</style>
